module.exports = __webpack_public_path__ + "static/media/vba.722bc71d.png";